export const ucfirst = (str) => str.charAt(0).toUpperCase() + str.slice(1)
export const toFloat = (i) => Number(parseFloat(i).toFixed(1))
// @todo stop smoking handler 1
export const stopPropagation = (e) => {
  e.stopPropagation()
  e.nativeEvent.stopImmediatePropagation()
}

export const serialize = ({ elements }) =>
  Array.from(elements).reduce((acc, input) => {
    if (input.name) {
      switch (input.type) {
        case 'checkbox':
          acc[input.name] = input.checked
          break
        default:
          acc[input.name] = input.value
      }
    }

    return acc
  }, {})

export const noop = () => {}

const EMAIL_PATTERN =
  /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/

export const assert = {
  emailAddress: (str) => str.length > 0 && EMAIL_PATTERN.test(str),
}

export const normalize = (str) => str.trim().replace(/\s\s+/g, ' ')

export const isFigma =
  /https:\/\/www\.figma\.com\/(?:file\/(?<key>[^ $]*)\/(?<name>[^ $]*)\?type=design&node-id=(?<node>[^ $&]*)|design\/(?<key2>[^ $]*)\/(?<name2>[^ $]*)\?node-id=(?<node2>[^ $&]*)(&mode=[^ $&]*)?(&t=[^ $&]*)?)/i

export const isFigmaUrl = (url) => isFigma.test(url)

export const centerPage = () => {
  const treeFrame = document.querySelector('.Tree')
  const exportNode = document.querySelector('#printed-node')

  if (treeFrame && exportNode) {
    const { width } = exportNode.getBoundingClientRect()

    treeFrame.scrollTo(width / 2 - window.innerWidth / 2, 0)
  }
}

export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
)

export const niceBytes = (bytes, decimals = 1, showType = true) => {
  if (bytes === 0) {
    return '0 MB'
  }

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const type = i === 0 || i === 1 ? 'MB' : sizes[i]
  let calc = parseFloat((bytes / k ** i).toFixed(dm))

  if (i === 0) {
    calc = byteToMB(calc)
  }

  if (i === 1) {
    calc = kbToMB(calc)
  }

  if (showType) {
    return `${calc} ${type}`
  }

  return calc
}

const byteToMB = (byte) => {
  return (byte / 1024 / 1024).toFixed(1)
}

const kbToMB = (kb) => {
  return (kb / 1024).toFixed(3)
}

export const isContainsOnlySpaces = (str) => {
  return str.length > 0 && str.trim().length === 0
}

const urlPattern = new RegExp(
  '^((https?|ftp):\\/\\/)?' + // protocol
    '(([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}' + // host
    '(\\:\\d+)?' + // port
    '(\\/[-a-z\\d%_.~+()#]*)*' + // path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // search
    '(\\#[-a-z\\d_]*)?$', // hash
  'i'
)

export const isValidUrl = (str) => !!urlPattern.test(str)

const emailPattern = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
export const isValidEmail = (str) => !!emailPattern.test(str)

export const addProtocol = (url) => {
  if (!/^(?:f|ht)tps?:\/\//.test(url)) {
    url = `http://${url}`
  }

  return url
}

export const removeProtocolFromUrl = (url) => url?.replace(/(^\w+:|^)\/\//, '')

// @todo stop smoking handler 2
export const preventDefaultHandler = (e) => {
  e.preventDefault()
}

// @todo stop smoking handler 3
export const stopPropagationHandler = (e) => {
  e.stopPropagation()
}

// @todo stop smoking handler 4
export const stopPropagationPreventDefaultHandler = (e) => {
  e.stopPropagation()
  e.preventDefault()
}
